import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeSlotId: null,
};

const activeSlotSlice = createSlice({
  name: "activeSlot",
  initialState,
  reducers: {
    setactiveSlot: (state, action) => {
      state.activeSlotId = action.payload;
    },
    clearActiveSlot: (state) => {
      state.activeSlotId = null;
    },
  },
});

export const { setactiveSlot, clearActiveSlot } = activeSlotSlice.actions;
export default activeSlotSlice.reducer;

